import { createAction } from '@reduxjs/toolkit'

import type { TSourceTablePreviewResponse } from 'redux/api/DataPlatform/connections/sourceTables/v1'

import type { TActiveSourcePayload } from '../Sources/actions'

// tryUpdateSourceTable
export const update = createAction('update_source_table')
export const updateSuccess = createAction<TActiveSourcePayload>(
  'update_source_table_success'
)
export const updateFailed = createAction('update_source_table_failed')

// tryGetSourceTablePreview
export const getPreview = createAction<{ id: string }>(
  'get_source_table_preview'
)
export const getPreviewSuccess = createAction<{
  data: TSourceTablePreviewResponse
  limit: number
  offset: number
}>('get_source_table_preview_success')
export const getPreviewFailed = createAction('get_source_table_preview_failed')

// tryDeleteSourceTable
export const destroy = createAction('destroy_source_table')
export const destroySuccess = createAction<
  TActiveSourcePayload & { deletedId: string }
>('destroy_source_table_success')
export const destroyFailed = createAction('destroy_source_table_failed')
